
import { mxCylinder, mxPoint, mxConnectionConstraint } from "../utils/graph/mxModule";
// const mxModule = require("mxgraph")();
// const {
//     mxCylinder, mxPoint, mxConnectionConstraint
//   } = mxModule;



function inputPinShape() {}

inputPinShape.prototype = new mxCylinder();
inputPinShape.prototype.constructor = inputPinShape;

inputPinShape.prototype.constraints = [
    new mxConnectionConstraint(new mxPoint(0.5, 0.5), false),  // input
  ];

inputPinShape.prototype.paintVertexShape = function(c, x, y, w, h) {
  const dx = w / 50;
  const dy = h / 40;

  c.setStrokeColor('green');
  c.setFillColor('red');
  c.setStrokeWidth(1);

  c.begin();

  // Move to (0,0)
  c.moveTo(x + dx * 0, y + dy * 0);
  // Line to (30,0)
  c.lineTo(x + dx * 30, y + dy * 0);
  // Line to (50,20)
  c.lineTo(x + dx * 50, y + dy * 20);
  // Line to (30,40)
  c.lineTo(x + dx * 30, y + dy * 40);
  // Line to (0,40)
  c.lineTo(x + dx * 0, y + dy * 40);
  // Close the shape
  c.close();

  c.fillAndStroke();
};

export default inputPinShape;